import { render } from "./CCSupport.vue?vue&type=template&id=1c23e632&scoped=true"
const script = {}

import "./CCSupport.vue?vue&type=style&index=0&id=1c23e632&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c23e632"]])

export default __exports__